<template>
<div style="overflow: hidden;">
  <el-form inline>
    <el-form-item >
      <el-select v-model.trim="formData.brand_id" placeholder="请输入品牌" clearable filterable class="input"
                 @Change="changeCatalogByBrand(formData.brand_id)">
        <el-option v-for="item in brandList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item >
      <el-select v-model.trim="formData.catalog_id" placeholder="请输入品类" clearable filterable class="input">
        <el-option v-for="item in catalogList" :key="item.id" :label="item.catalog_name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item >
      <el-input v-model="formData.material_code" placeholder="请输入料号" clearable class="input"/>
    </el-form-item>
    <el-form-item>
      <el-button @click="queryGuideImage">查询</el-button>
    </el-form-item>
    <el-form-item>
      <FrameButton :button="showAdd()"/>
    </el-form-item>
  </el-form>
  <div style="height: 87%;width:100%;overflow: auto;margin-bottom: 10px">
    <el-table :data="currentPageData" stripe border highlight-current-row>
      <el-table-column label="品牌" prop="brand_name" width="150"></el-table-column>
      <el-table-column label="品类" prop="catalog_name" width="150"></el-table-column>
      <el-table-column label="料号" prop="material_code" width="150"></el-table-column>
      <el-table-column label="照片" prop="imageList">
        <template #default="scope">
          <KfImageViewer :imageList="scope.row.imageList" v-if="scope.row.imageList.length > 0"/>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template #default="scope">
          <el-row >
            <el-col :span="12">
              <FrameButton :button="showEdit()" :parentData="scope.row"/>
            </el-col>
            <el-col :span="12">
              <el-button type="danger" text @click="deleteData(scope.row)">删除</el-button>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div style="width:100%;text-align: right">
    <!-- 分页部分 -->
    <el-pagination
        background
        layout="total,sizes, prev, pager, next"
        :total="guideImageList.length"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        :current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        style="justify-content: flex-end;margin-right: 10px"
    />
  </div>

</div>

</template>

<script>
import {ElMessage, ElMessageBox} from "element-plus";


export default {
  name: "RepairGuideImage",
  inject: ['$fn'],
  props: {},
  data() {
    return {
      formData:{},
      brandList:[],
      catalogList:[],
      guideImageList:[],
      currentPage: 1,     // 当前页码
      pageSize: 10,  // 每页显示条数
    }
  },
  provide() {
    return {
      $fn: {
        search: () => {
          this.queryGuideImage();
        }
      }
    }
  },
  computed: {
    // 计算当前页显示的数据
    currentPageData() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.guideImageList.slice(start, end)
    },
  },
  created() {
    this.queryGuideImage()
    this.getBrandList()
  },
  mounted() {
  },
  methods: {

    // 每页条数改变
    handleSizeChange(val) {
      console.log("val-=",val)
      this.pageSize = val
      this.currentPage = 1 // 重置到第一页
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val
    },

    //获取品牌
    async getBrandList() {
      this.brandList = await this.$http('repairDsService.getAllBrand')
    },
    //根据品牌获取品类
    async changeCatalogByBrand(brandId) {
      this.catalogList = await this.$http('repairCatalogService.getCatalogList', {brand_id: brandId})
    },

    showAdd(){
      let button = {
        "component": "button",
        "click": "jsOpenWindow",
        "label":"添加"
      }

      let windowObj = {}
      windowObj.icon = "system/tools";
      windowObj.component = "frame/FrameForm";
      windowObj.params = "repair_guide_image_add";
      windowObj.type = "repair_guide_image_add";
      windowObj.title = "添加";
      windowObj.width = 800
      windowObj.height = 600
      windowObj.max = false

      button.window = windowObj
      return button

    },

    async queryGuideImage() {
      this.guideImageList = await this.$http('repairGuideImageService.queryGuideImage', this.formData)
    },

    showEdit(){
      let button = {
        "component": "button",
        "type": "primary",
        "text":true,
        "click": "jsOpenWindow",
        "label":"编辑"
      }

      let windowObj = {}
      windowObj.icon = "system/tools";
      windowObj.component = "frame/FrameForm";
      windowObj.params = "repair_guide_image_edit";
      windowObj.type = "repair_guide_image_edit";
      windowObj.title = "编辑";
      windowObj.width = 800
      windowObj.height = 600
      windowObj.max = false

      button.window = windowObj
      return button

    },

    async deleteData(guideImage){
      ElMessageBox.confirm(
          '确定要删除这条指导图片吗？',
          '提示',
          {
            confirmButtonText: '确定',
            type: 'warning',
            draggable: true,
            overflow: true,
          }
      )
          .then(async () => {
            await this.$http('repairGuideImageService.deleteGuideImage', guideImage)
            await this.queryGuideImage()
            ElMessage({
              type: 'success',
              message: '操作成功',
            })
          })
    },
    
  }
}
</script>

<style scoped>

.input {
  height: 32px;
  width: 200px;
  margin-right: 10px;
}

:deep  .el-form-item{
  margin-right: 10px;
}

</style>